<template>
  <tk-container class="feedback">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      意见反馈
    </tkui-header>
    <div class="body">
      <textarea v-model="content" class="form" cols="30" rows="10" placeholder="请给我们意见建议"></textarea>
      <tkui-button @click.native="up" class="block raised primary rounded">提交</tkui-button>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        content: ''
      }
    },
    methods: {
      back () {
        this.$back()
      },
      async up () {
        let bool = /^\s+$/g.test(this.content)
        if (!this.content || bool) {
          this.$tkGlobal.toast.add('请填写意见')
          return
        }
        try {
          await this.$tkParse.post('/classes/feedback', {
            'content': this.content
          })
          this.$tkGlobal.toast.add('意见提交成功')
          this.content = ''
        } catch (e) {
          this.$tkGlobal.toast.add('反馈意见失败')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .feedback{
    background: #ffffff;
    .body{
      padding:25px 15px;
      .form{
        width: 100%;
        height: 150px;
        border: 1px solid #cccccc;
        padding: 10px;
        font-size: 16px;
        color: #999999;
        resize: none;
        margin-bottom: 70px;
      }
    }
  }
  textarea::-webkit-input-placeholder {
    color: #999999;
    font-size: 16px;
    letter-spacing: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/page/app/user/feedBack.vue